/* Copyright 2026 Element Creations Ltd.
SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial */
/** Drive button navigation ourselves: native smooth scrolling plus mandatory
 * snapping can be completed abruptly by browsers while the active tile changes. */
export function animateCarouselScroll(
  element: HTMLElement,
  target: number,
  reducedMotion: boolean,
  onFinish: () => void,
): () => void {
  const previousSnap = element.style.scrollSnapType;
  const previousBehavior = element.style.scrollBehavior;
  const start = element.scrollLeft;
  let frame = 0;
  let started: number | undefined;
  let stopped = false;
  element.style.scrollSnapType = "none";
  element.style.scrollBehavior = "auto";
  const stop = (): void => {
    if (stopped) return;
    stopped = true;
    cancelAnimationFrame(frame);
    element.style.scrollSnapType = previousSnap;
    element.style.scrollBehavior = previousBehavior;
  };
  if (reducedMotion) {
    element.scrollLeft = target;
    stop();
    onFinish();
    return stop;
  }
  const tick = (time: number): void => {
    if (stopped) return;
    started ??= time;
    const progress = Math.min(1, (time - started) / 320);
    const eased = progress * progress * (3 - 2 * progress);
    element.scrollLeft = start + (target - start) * eased;
    if (progress < 1) frame = requestAnimationFrame(tick);
    else { stop(); onFinish(); }
  };
  frame = requestAnimationFrame(tick);
  return stop;
}
